module.exports = __webpack_public_path__ + "media/images/project/book-f2e22e3f2feaf0ba295522323abb6ca9.svg";